import React, { useContext } from 'react';

import { useTranslation } from 'next-i18next';

import { getAsset } from '../../../helpers';
import { IBlog } from '../Blog.types';

interface IBlogContext {
  children: React.ReactNode;
  blogTagsList?: string[];
  topPosts?: {
    post: Partial<IBlog>;
  }[];
}

interface IBlogContextValue {
  topPostsList?: {
    path?: string;
    title?: string;
    img?: { path: string; alt: string } | null;
  }[];
  tagsCountNumber?: Record<string, number>;
}

const BlogContext = React.createContext<IBlogContextValue | null>(null);

const BlogContextProvider = ({ children, topPosts, blogTagsList }: IBlogContext) => {
  const { t } = useTranslation('resources');

  const { blogPath } = t('blog', {
    returnObjects: true,
  }) as any;

  const topPostsList = topPosts?.map((topPost) => {
    if (!topPost.post.translations?.[0]) {
      return {};
    }

    const content = topPost.post.translations[0];
    const image = topPost.post.thumbnail;

    return {
      path: `${blogPath}${content.slug}/`,
      title: content.title_short || content.title,
      img: image ? getAsset(image, true) : null,
    };
  });
  const tagsCountNumber = blogTagsList?.reduce<Record<string, number>>((accumulator, value) => {
    return { ...accumulator, [value]: (accumulator[value] || 0) + 1 };
  }, {});

  return (
    <BlogContext.Provider
      value={{
        topPostsList,
        tagsCountNumber,
      }}
    >
      {children}
    </BlogContext.Provider>
  );
};

const useBlogContext = () => useContext(BlogContext);

export { BlogContextProvider, useBlogContext };
